<!-- src\components\AboutUs.vue -->
<template>
    <div class="page flex-col">
      <div class="main flex-col">
        <div class="content flex-col">
          <div class="btn-back flex-row justify-between" @click="$router.push('/')">
            <img class="img-back" referrerpolicy="no-referrer"
              src="../assets/img/MasterDDSSlicePNGc10f7b98a802e59b37af721c7a06e583.png" />
            <span class="text-back">返回</span>
          </div>
          <div class="text-content-container">
            <div class="heading_1">欢迎访问自动气象站虚拟仿真实训平台</div>
            <div class="paragraph">
              <p>本平台致力于为气象从业人员提供气象自动化装备的专业知识学习和虚拟仿真实训。我们旨在帮助气象工作者全面了解气象观测自动化装置的结构、原理、使用与维护等方面的知识，提高自动气象站的维护维修技能。</p>
            </div>
            <div class="heading_2">关于我们</div>
            <div class="paragraph">
              <p>广西气象培训中心是广西气象局下属的气象人才培养和继续教育基地，负责全区气象人员的培训和考核工作，专注于气象观测、预报、气象服务等方面的职业技能培训。中心师资力量雄厚，配备资深的气象行业专家和讲师团队，以及先进的教学设施和资源。&nbsp;</p>
              <p>本平台是我们为了适应气象行业发展和人才需求而建立的一个网络教育平台，网站的建设就是为了更好地发挥培训中心的专业优势，旨在通过网络平台为全区广大气象从业人员提供便捷、高效、实用的在线学习服务。</p>
            </div>
            <div class="heading_2">我们的使命</div>
            <div class="paragraph">
              <p>我们希望通过这个平台，向广大气象从业人员传递气象自动化装备的最新知识和技术，帮助他们系统地掌握自动气象站的专业知识，熟练地运用各项操作技能，能够高效且规范地完成自动气象站的安装、调试、维护和维修工作。</p>
              <p>这不仅可以提高气象从业人员的专业素养，也将直接提升自动气象站设备的稳定可靠运行。规范的操作和维护将大大减少设备故障，提高数据监测的连续性和准确性，为气象预报产品的精细化提供坚实的观测支撑。我们希望通过持续优化平台内容，全面提升气象自动化装备的性能和效果。&nbsp;</p>
              <p>同时，我们也希望通过这个平台，架起气象从业人员之间知识交流和经验分享的桥梁，促进他们之间的相互学习与合作，持续提高专业技能，增强对气象事业的热情与责任感，共同推动气象科学技术与事业的进步。</p>
              <p>新的自动气象站虚拟仿真实训平台，增加了虚拟仿真和虚拟漫游功能，用户可以在虚拟环境中体验气象自动化设备的操作和维护，同时虚拟漫游中可以获取设备相关信息，提高学习效果。</p>
            </div>
            <div class="heading_2">联系方式</div>
            <div class="heading_3">广西壮族自治区气象培训中心</div>
            <div class="paragraph">
              <p>姓名：吴天明</p>
              <p>电话：0771-5847394</p>
              <p>邮箱：382714263&#64;qq.com</p>
              <p>地址：广西南宁市青秀区新竹路北二里11号</p>
            </div>
          </div>
        </div>
        <span class="footer">广西壮族自治区气象培训中心</span>
      </div>
    </div>
  </template>

<script>
export default {
    name: 'AboutUs'
}
</script>

<style scoped lang="css" src="../assets/index.rem-AboutUs.css" />